import { TickFilledIcon } from '@mote/assets/icons'
import { Block } from '@mote/ui'
import { StyledImage } from '../ToteCardComponent.styles'
import { getMemeSrc } from '../helpers'
import { MemeContainer } from './Teply.styles'
import { Tesponse } from './Tesponse'
import { Container, Header, LinkButton } from './Tesponse.styles'
import { useMemeTimeout } from './useMemeTimeout'

/**
 * @typedef {Object} StundetTesponseProps
 * @property {number} lastSeenDate
 * @property {string} studentName
 * @property {string} image
 * @property {string | null} tesponse
 * @property {string} mode
 * @property {boolean} shouldShowMeme
 * @property {() => void} onChangeResponse
 */

/**
 * @param {StundetTesponseProps} props
 * @return {JSX.Element}
 */
export function StundentTesponse(props) {
  const shouldShowMeme = useMemeTimeout(props.shouldShowMeme)

  if (shouldShowMeme) {
    return (
      <MemeContainer>
        <StyledImage src={getMemeSrc(props.mode, props.image)} />
      </MemeContainer>
    )
  }

  return (
    <Container className='mote-tote-card__tesponse' gap={16}>
      <Header>
        <Block layout='horizontal' align='center' gap={8}>
          <TickFilledIcon
            color={{ background: '#57C96A' }}
            width='1em'
            height='1em'
          />
          You responded
        </Block>
      </Header>
      <Tesponse mode={props.mode} tesponse={props.tesponse} />
      <Block layout='horizontal' align='center' justify='flex-end'>
        <LinkButton
          aria-label='Change response'
          text='Change response'
          onClick={props.onChangeResponse}
        />
      </Block>
    </Container>
  )
}
